/* global ShopgateProductDetailsCore, pageInformation */
import AbstractAmazonPay from './AbstractAmazonPay';
import AmazonPayUIFactory from '../../common/amazon-pay/AmazonPayUIFactory';
/**
 * AmazonPayButton class
 */
class AmazonPayButton extends AbstractAmazonPay {
  /**
   * @inheritdoc
   */
  constructor(opts, $, SGEvent, SGAction, sgData, sgWebStorage = null) {
    super(opts, $, SGEvent, SGAction, sgData, sgWebStorage);
    this.button = this.$();
    this.namespace = 'AmazonPayButton';
    this.cartForm = this.$();
    this.bindButtonHandler = this.bindButtonHandler.bind(this);
  }

  buildButton() {
    this.button = this.$('.payment-btn.amazon');
    this.button.attr('title', 'AmazonPay');
  }

  /**
   * Starts pay button listener.
   */
  bindButtonHandler() {
    const spinnerEvents = this.$.shopgate.spinner().getEvents();
    this.$.shopgate.spinner()
      .off(`${spinnerEvents.SPINNER_HIDDEN}.${this.namespace}`)
      .on(`${spinnerEvents.SPINNER_HIDDEN}.${this.namespace}`, () => {
        this.button.removeClass('locked');
      });

    this.button
      .off(this.namespace)
      .on(`click.${this.namespace}`, () => {
        if (this.button.hasClass('locked')) {
          return;
        }
        this.button.addClass('locked');

        if (typeof ShopgateProductDetailsCore === 'object') {
          ShopgateProductDetailsCore.setStateCartButtonBusy(true);
        }

        this.$.shopgate.spinner('show');

        this.SGAction.amazonPayStart({
          scopes: this.getScopes(),
          region: this.region,
          ledgerCurrency: this.currency,
        });
      });
  }

  /**
   * Initialize the necessary functionality for the payment buttons locking on product details page
   */
  initPDPlugin() {
    const that = this;
    this.isAmazonPaySupported()
      .then(() => {
        // UI Plugin for product details
        const amazonPaymentUI = new AmazonPayUIFactory(
          that.button,
          'sgapi:ajax_get_minimum_order_value',
          that.bindButtonHandler,
          this.logger
        ).getPlugin();

        // Register as product details plugin if available
        if (
          typeof ShopgateProductDetailsCore === 'object'
          && typeof ShopgateProductDetailsCore.registerPlugin === 'function'
        ) {
          ShopgateProductDetailsCore.registerPlugin(amazonPaymentUI);
        }
      })
      .catch(() => {
        // Nothing
      });
  }

  removeButton() {
    const button = this.$('.payment-btn.amazon');
    button.remove();
  }

  /**
   * Register app events, bind click events and create the button (add the button image)
   * @param {boolean} isCartPage if it's cart page will do cart specific things
   */
  initButton(isCartPage) {
    this.isAmazonPaySupported()
      .then(() => {
        this.registerEvents();
        this.buildButton();
        this.bindButtonHandler();
        if (isCartPage) {
          this.initCartSpecifics();
        }
      })
      .catch((e) => {
        this.logger.error('Error occured.', e);
        this.removeButton();
      });
  }

  /**
   * Handles things specific for cart page.
   */
  initCartSpecifics() {
    this.cartForm = this.$('.cart form');
    const cartCheckoutButton = this.$('.cart-checkout-button');
    const refId = this.button.data('ref-id');
    const CtaButtonCallbackName = `menuBarCtaButtonPressed.${this.namespace}`;
    const amazonDidLogOutCallbackName = `amazonDidLogOut.${this.namespace}`;
    const userLoggedInCallbackName = `userLoggedIn.${this.namespace}`;
    const userLoggedOutCallbackName = `userLoggedOut.${this.namespace}`;

    if (refId && this.cartForm.length) {
      this.logger.info('Found refId, user is logged in to Amazon. Blocking normal submit.');
      this.cartForm.data('submitOverridden', true);
      // Handling layout with menubar buttons
      this.SGEvent
        .unregisterCallback(CtaButtonCallbackName)
        .registerCallback(CtaButtonCallbackName, (data) => {
          if (!data.type || data.type !== 'cart') {
            return;
          }

          // Unregister the concurrent event
          cartCheckoutButton.off(this.namespace);
          this.button.click();
        });

      // Handling alternating layout without menubar buttons
      cartCheckoutButton
        .on(`click.${this.namespace}`, (e) => {
          // Unregister the concurrent event
          this.SGEvent.unregisterCallback(CtaButtonCallbackName);
          e.preventDefault();
          this.button.click();
        });
    } else {
      this.logger.info('No refId found. Making sure submit is working in a regular way.');
      this.cartForm.data('submitOverridden', false);
      cartCheckoutButton.off(this.namespace);
      this.SGEvent.unregisterCallback(CtaButtonCallbackName);
    }

    this.SGEvent
      .unregisterCallback(amazonDidLogOutCallbackName)
      .unregisterCallback(userLoggedInCallbackName)
      .unregisterCallback(userLoggedOutCallbackName)
      .registerCallback(amazonDidLogOutCallbackName, this.handleAmazonDidLogOut)
      .registerCallback(userLoggedInCallbackName, this.handleUserLoggedInStateChange)
      .registerCallback(userLoggedOutCallbackName, this.handleUserLoggedInStateChange);
  }
}

export default AmazonPayButton;



// WEBPACK FOOTER //
// ./Library/1.0/app/amazon-pay/AmazonPayButton.js